import axios from 'axios'

import { OrderForm } from '../../entity/orderForm'
import type { CustomDataBody } from '../types/customData'

export const addCartCustomData = async (
  orderFormId: string,
  body: CustomDataBody
) => {
  try {
    const { data } = await axios.put(
      `https://decathlonstore.myvtex.com/v1/checkout/pub/orderForm/${orderFormId}/customData/${body.appId}`,
      body.customData,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    return new OrderForm(data)
  } catch (error) {
    throw new Error('addCartCustomData:', error)
  }
}
